import React, {Component} from 'react';
import {Button, Card, Form, Input, message, Table} from 'antd';
import moment from 'moment';
import {BackBtn} from '@comm/BackBtn';
import {queryDiscountList} from '@api/incubator/settled';

const FormItem = Form.Item;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
      },
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData = () => {
    const params = {
      incubatorUuid: this.props.params.uuid,
      ...this.searchCondition,
      ...this.pagination,
      ...this.sorter,
    };
    this.getDiscountList(params);
  };

  handleSubmit = e => {
    if (e) {
      e.preventDefault();
    }
    const values = this.props.form.getFieldsValue();
    this.searchCondition = { ...values };
    this.getData();
  };

  handleTableChange = pagination => {
    this.pagination = {
      limit: pagination.pageSize,
      start: pagination.current,
    };
    this.current = pagination.current;
    this.getData();
  };

  getDiscountList = params => {
    queryDiscountList(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataSource: {
            list: res.data,
            pagination: {
              total: res.totalSize,
              pageSize: 15,
              current: this.current || 1,
            },
          },
        });
      } else {
        message.error(res.message);
      }
    });
  };

  columns = () => {
    return [
      {
        title: '合同创建日期',
        dataIndex: 'createTime',
        render: (text, record) => (
          <span>
            {record.createTime ? moment.unix(record.createTime).format('YYYY-MM-DD') : null}
          </span>
        ),
      },
      {
        title: '合同类型',
        dataIndex: 'type',
      },
      {
        title: '公司名称',
        dataIndex: 'custom',
      },
      {
        title: '数量（个）',
        dataIndex: 'stationNum',
      },
      {
        title: '实际金额（元）',
        dataIndex: 'price',
      },
      {
        title: '折后金额（元）',
        dataIndex: 'discount',
      },
      {
        title: '折扣（%）',
        dataIndex: 'price1',
      },
      {
        title: '剩余天数',
        dataIndex: 'interval',
      },
    ];
  };

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Form layout="inline" onSubmit={this.handleSubmit}>
        <FormItem label="搜索条件">
          {getFieldDecorator('condition')(<Input placeholder="请输入关键字搜索" />)}
        </FormItem>
        <FormItem>
          <Button type="primary" htmlType="submit">
            查询
          </Button>
          <Button style={{ marginLeft: 8 }} onClick={this.handleFormReset}>
            重置
          </Button>
        </FormItem>
      </Form>
    );
  };

  render() {
    const {
      dataSource: { list, pagination },
    } = this.state;
    return (
      <div>
        <div style={{ marginBottom: '16px' }}>
          <BackBtn />
        </div>
        <Card title="折扣清单表">
          <div
            style={{
              marginBottom: '16px',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            {this.renderSearchForm()}
            <Button>导出列表</Button>
          </div>
          <Table
            columns={this.columns()}
            dataSource={list}
            pagination={pagination}
            onTableChange={this.handleTableChange}
          />
        </Card>
      </div>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Index);



// WEBPACK FOOTER //
// ./src/components/incubator/one/PageDiscount.js